// extracted by mini-css-extract-plugin
export default {"PrivacyPanelContent":"BKguYPQnfp"};